export const INSTAGRAM_URL = "https://www.instagram.com/medycynaestetycznalegnicapl";
export const FB_URL = "https://www.facebook.com/medycynaestetycznalegnica"